import CarrierServices from './CarrierServices';
import RateAdvisor from './RateAdvisor.component';

export default { RateAdvisor, CarrierServices };
